module.exports = __webpack_public_path__ + "static/img/mouth_08.abda9bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_08.png
// module id = eAfh
// module chunks = 0